import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponent), {
    role: "img",
    class: "inline-block",
    fill: _ctx.fill,
    status: _ctx.status
  }, null, 8, ["fill", "status"]))
}